import { render, staticRenderFns } from "./GChatUploadButton.vue?vue&type=template&id=2f1a21d0&scoped=true&"
import script from "./GChatUploadButton.vue?vue&type=script&lang=ts&"
export * from "./GChatUploadButton.vue?vue&type=script&lang=ts&"
import style0 from "./GChatUploadButton.vue?vue&type=style&index=0&id=2f1a21d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a21d0",
  null
  
)

export default component.exports